/** Buyer布局 */

import { Box, Container, AppBar, Toolbar, Typography, IconButton, Avatar } from '@mui/material';
import { ShoppingCart, LocalShipping, Description, Gavel } from '@mui/icons-material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '@/contexts/AppContext';
import { Tabs, Tab } from '@mui/material';
import { COLORS } from '@/theme/colors';

const buyerTabs = [
  { label: '订单付款', path: '/buyer/payment', icon: <ShoppingCart /> },
  { label: '履约追踪', path: '/buyer/tracking', icon: <LocalShipping /> },
  { label: '单证报告', path: '/buyer/documents', icon: <Description /> },
  { label: '理赔中心', path: '/buyer/claims', icon: <Gavel /> },
];

export default function BuyerLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppContext();

  const currentTab = buyerTabs.findIndex((tab) => location.pathname.startsWith(tab.path));

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: COLORS.grey[50], position: 'relative' }}>
      <AppBar position="sticky" sx={{ backgroundColor: COLORS.background.paper, color: COLORS.text.primary, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <Toolbar>
          <Box
            component="img"
            src="/logo/star-icon.jpg"
            alt="BluPlanet"
            sx={{ width: 28, height: 28, borderRadius: '6px', objectFit: 'contain', flexShrink: 0 }}
          />
          <Typography variant="h6" sx={{ flex: 1, fontWeight: 700, color: COLORS.primary.main, fontSize: '1.0625rem' }}>
            BluPlanet
          </Typography>
          <Avatar sx={{ width: 32, height: 32, bgcolor: COLORS.success.main, fontSize: '0.75rem' }}>
            {user.name?.charAt(0) || '?'}
          </Avatar>
        </Toolbar>
        <Tabs
          value={currentTab >= 0 ? currentTab : 0}
          onChange={(_, v) => navigate(buyerTabs[v].path)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': { minWidth: 'auto', px: 1.5, py: 1, fontSize: '0.75rem', fontWeight: 500 },
            '& .MuiTabs-indicator': { backgroundColor: COLORS.primary.main },
            '& .Mui-selected': { color: `${COLORS.primary.main} !important` },
          }}
        >
          {buyerTabs.map((tab) => (
            <Tab key={tab.path} label={tab.label} icon={tab.icon} iconPosition="start" />
          ))}
        </Tabs>
      </AppBar>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Container maxWidth="sm" sx={{ py: 2 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}
